export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/cross.3b67d708.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};